export function extractErrors(error, json) {
    if (json.error) {
        const errorText = `Ошибка. Статус: ${error.status}; Текст: ${json.error};`;
        return { global: errorText };
    } else if (json.status) {
        return { global: json.message };
    } else {
        const errors = Object.assign(
            {}, ...Object.keys(json).map(field => {
                return {[field]: extractErrorText(json[field])};
            })
        );
        return errors;
    }
}

function extractErrorText(error) {
    if (error instanceof Array) {
        return error[0]
    } else {
        return error;
    }
}
